module.exports = __webpack_public_path__ + "media/unipod/pos_assembly_3-f22ef1d9.jpg";